import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'

const Torox = ({ user, settings }) => {

    const history = useNavigate()
    const [isLoading, setIsLoading] = useState(true)
    const [shouldRedirect, setShouldRedirect] = useState(false)
    const [wallUrl, setWallUrl] = useState(null)

    useEffect(() => {
        // Wait for both user and settings to be actually loaded (not null/undefined)
        if (user && settings !== null && settings !== undefined) {
            setIsLoading(false)
            
            if (!settings.torox || !user) {
                setShouldRedirect(true)
                return
            }
        }
    }, [user, settings])

    useEffect(() => {
        if (shouldRedirect) {
            history('/')
            return
        }
    }, [shouldRedirect, history])

    useEffect(() => {
        // Only run when valid data is available
        if (isLoading || shouldRedirect || !settings?.torox) {
            return
        }

        let aborted = false

        const loadWall = async () => {
            try {
                const res = await fetch(process.env.REACT_APP_SERVER_URL + `/walls/torox/session`, {
                    method: 'POST',
                    credentials: 'include',
                    headers: { 'Content-Type': 'application/json' }
                })

                const data = await res.json()
                if (!aborted && data && data.wallUrl) {
                    setWallUrl(data.wallUrl)
                } else if (!aborted) {
                    setShouldRedirect(true)
                }
            } catch (e) {
                if (!aborted) {
                    setShouldRedirect(true)
                }
            }
        }

        loadWall()
        return () => { aborted = true }
    }, [isLoading, shouldRedirect, settings?.torox])

    if (isLoading) {
        return <div>Loading...</div>
    }

    if (shouldRedirect) {
        return null;
    }

    return (
        <>
            <div className="wall-container">
                {wallUrl && (
                    <iframe
                        id='torox-iframe'
                        src={wallUrl}
                    />
                )}
            </div>

            <style jsx>{`
                .wall-container {
                    width: 100%;
                    height: 100%;
                }
                iframe {
                    width: 100%;
                    height: 100%;
                    border: none;
                    border-radius: 8px;
                    margin-top: 20px;
                }
            `}</style>
        </>
    );
};

export default Torox;